import { render, staticRenderFns } from "./FacilityAssetReleaseTable.vue?vue&type=template&id=c019cb48&scoped=true"
import script from "./FacilityAssetReleaseTable.vue?vue&type=script&lang=js"
export * from "./FacilityAssetReleaseTable.vue?vue&type=script&lang=js"
import style0 from "./FacilityAssetReleaseTable.vue?vue&type=style&index=0&id=c019cb48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c019cb48",
  null
  
)

export default component.exports